exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.vnis *,\n.vnis *::after,\n.vnis *::before {\n  box-sizing: border-box;\n}\n.vnis__input {\n  -webkit-appearance: none;\n  border: 1px solid #ebebeb;\n  float: left;\n  font-size: 16px;\n  height: 40px;\n  margin: 0;\n  outline: none;\n  text-align: center;\n  width: calc(100% - 80px);\n}\n.vnis__input::-webkit-outer-spin-button, .vnis__input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n}\n.vnis__button {\n  -webkit-appearance: none;\n  transition: background 0.5s ease;\n  background: #387e90;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  float: left;\n  font-size: 20px;\n  height: 40px;\n  margin: 0;\n  width: 40px;\n}\n.vnis__button:hover {\n    background: #469eb5;\n}\n.vnis__button:focus {\n    outline: 1px dashed #69b2c5;\n    outline-offset: -5px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-122462c4","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NumberInputSpinner.vue
// module id = 4
// module chunks = 0